import { useGetUserInfo } from '@/modules/Auth'
import { OfficialReportType } from '@/types/officialReport'
import styles from '../OfficialReportModal.module.scss'

import { isHeadwayOfficialReportType, isLateOfficialReportType } from '../../helpers/checkReportType'

import { LateTime } from './LateTime'
import { ReportTime } from './ReportTime'
import { Headway } from './Headway'

interface Props {
    reportType: OfficialReportType
}

export const CommonInformation = ({ reportType }: Props) => {
    const { data: userInfo } = useGetUserInfo()

    if (!userInfo) {
        return null
    }

    return (
        <div className={styles.wrapper}>
            <div className={styles.informationWrapper}>
                <span className={styles.label}>Official writing report</span>
                {userInfo.lastSessionDetails.badgeNumber ? (
                    <span className={styles.text}>Badge no. {userInfo.lastSessionDetails.badgeNumber}</span>
                ) : (
                    <span className={styles.text}>{userInfo.lastSessionDetails.authorName}</span>
                )}
            </div>
            <ReportTime reportType={reportType} />
            {isLateOfficialReportType(reportType) && <LateTime reportType={reportType} />}
            {isHeadwayOfficialReportType(reportType) && <Headway />}
        </div>
    )
}
